import moment from 'moment';

export function strToMoment(date: string): moment.Moment {
  return moment(date, moment.ISO_8601, true);
}